export const Theme = {
  colors: {
    primary: "#fbeec2",
    secondary: "#accec0",
    background: "#F2E9e6",
    backgroundConfirm: "#95de90",
    text: "#605951",
    light: "#c1b398",
    confirm: "#61a6ab",
    remove: "#ff6161",
    note: "#FDFDC9",
    disabledText: "#a1a1ad",
  },
  fonts: {
    title: "Satisfy, cursive",
    text: "Titillium Web, sans-serif",
  },
  fontSizes: {
    small: "18px",
    medium: "24px",
    large: "50px",
    big: "128px",
  },
  spacing: {
    small: "8px",
    medium: "16px",
    large: "24px",
  },
};
